'use client'

import type {KeyTextField} from '@prismicio/client'
import {useSearchParams} from 'next/navigation'
import type {HeroV2SliceBentoDynamicPrimaryGridAssetsItem} from 'prismicio-types'
import {useEffect, useState} from 'react'
import {EVENTS, track} from 'src/common/helpers'

type UTMTrackerProps = {
  pageUid: string
  componentIndex: number
  heading?: string
  subtext?: KeyTextField
  images: HeroV2SliceBentoDynamicPrimaryGridAssetsItem | null
}

export function useUtmTermTracker({pageUid, componentIndex, heading = '', subtext, images}: UTMTrackerProps) {
  const search = useSearchParams()
  const [hasFired, setHasFired] = useState(false)
  const utm = search.get('utm_term') ?? null

  // Fire event only once when utm_term is set
  useEffect(() => {
    if (!utm || hasFired) {
      return
    }

    track({
      event: EVENTS.DYNAMIC_LP,
      customParams: {
        utm_term: utm,
        heading,
        subtext: subtext || '',
        images: JSON.stringify({
          top_left: images?.top_left?.url || '',
          top_right: images?.top_right?.url || '',
          bottom: images?.bottom?.url || '',
        }),
        location: `component-${componentIndex}-hero`,
        pageName: pageUid,
      },
    })

    setHasFired(true)

    // eslint-disable-next-line react-hooks/exhaustive-deps -- We only want to run this effect when `utm_term` changes
  }, [utm, hasFired])
}
